export const publicListings = [
    {
        id: `${String(Math.random()).replace(".", "_")}`,
        title: "Active Buyers",
        img: "/images/newLanding/realtor1.svg",
        body: "Directly connect with active buyers with details on exactly what they are in the market for.  Close deals fast & smart."
    },
    {
        id: `${String(Math.random()).replace(".", "_")}`,
        title: "Opportunities not on MLS",
        img: "/images/newLanding/realtor2.svg",
        body: "Post & discover private listings on Zonado to give them greater reach and your clients an edge with exclusive listings."
    },
    {
        id: `${String(Math.random()).replace(".", "_")}`,
        title: "Technology that works for you",
        img: "/images/newLanding/realtor3.svg",
        body: "Our algorithms will match your listing with the buyer looking for something similar instantly. "
    }
]

export const publicListingTools = [
    {
        id: `${String(Math.random()).replace(".", "_")}`,
        title: "Private & secure listing files",
        img: "/images/newLanding/realtor5.svg",
        body: "Upload listing documents and mark them as private for full control over who can gain access."
    },
    {
        id: `${String(Math.random()).replace(".", "_")}`,
        title: "In-built NDA",
        img: "/images/newLanding/realtor6.svg",
        body: "Send NDAs with the click of a button and share confidential information with confidence."
    },
    {
        id: `${String(Math.random()).replace(".", "_")}`,
        title: "In-app messaging and lead vetting",
        img: "/images/newLanding/realtor7.svg",
        body: "Spend  time talking to the right buyers, without losing track in the clutter of your email."
    },
    {
        id: `${String(Math.random()).replace(".", "_")}`,
        title: "Advanced analytics",
        img: "/images/newLanding/realtor8.svg",
        body: " With live data for all listings, track how it’s performing and who is showing interest so you can convert leads into commissions."
    }
]